{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Se alla alternativ",
  "Spoiler_Reveal_Tooltip": "Klicka för att avslöja",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "Tweeta det här",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Objektet är minimerat",
  "Spoiler_Reveal_Video_CTA": "Visa video",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "Förstora bild",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "Se alla resultat",
  "Spoiler_Reveal_Image_Placeholder": "Bilden innehåller en spoiler",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Sökreglage",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "Du kan rösta på mer än ett alternativ.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Visa fler ljudkontroller",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "Stäng",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "Läser in {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "Användaravatar",
  "Preview_ReadMore_Label": "Läs mer",
  "Spoiler_Insert_Tooltip": "Spoiler",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Volym",
  "Spoiler_Reveal_Gallery_Placeholder": "Galleriet innehåller en spoiler",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "Boka nu",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Slå på ljud",
  "Spoiler_Reveal_Gallery_CTA": "Visa galleri",
  "Poll_Viewer_ShowLess_CTA": "Visa mindre",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Stäng av ljud",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} anonyma",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Följ",
  "VerticalEmbed_Products_Button": "Köp nu",
  "Poll_Viewer_Toast_Error_ServerDown": "Kunde inte ansluta till servern. Försök igen senare.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} person har röstat på det här svaret",
  "Poll_Viewer_VoteCount": "{{number}} röster",
  "VerticalEmbed_Events_Button": "Registrera dig nu",
  "Spoiler_Reveal_Image_CTA": "Visa bild",
  "Poll_Viewer_Toast_Error_Connection": "Inget internet. Kontrollera din uppkoppling.",
  "Poll_Viewer_Visibility_Owner_Footer": "Det är bara du som kan se resultaten.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} personer har röstat på det här svaret",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Objektet är expanderat",
  "Audio_Plugin_Cover_Alt": "Ljudomslag",
  "Spoiler_Reveal_Video_Placeholder": "Videon innehåller en spoiler",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "Se hela inlägget",
  "UploadFile_Viewer_Download": "Ladda ner {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}} t",
  "VerticalEmbed_Units_Minute": "{{minutes}} min",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
